import React, { useState, useEffect, useCallback } from 'react';
import {
  Grid, TextField, MenuItem, Button, Chip, Box, Typography,
  FormControl
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { postData } from '../API/Post';
import { deleteData } from '../API/Delete';
import fetchData from '../API/Fetch';

export default function CollaboratorManager({ brandId }) {
  const users = useSelector((state) => state.users);
  const [collaborators, setCollaborators] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');

  const loadCollaborators = useCallback(async () => {
    try {
      const response = await fetchData(
        `/api/brands/${brandId}/collaborators`
      );
      setCollaborators(response || []);
    } catch (error) {
      setCollaborators([]);
    }
  }, [brandId]);

  useEffect(() => {
    if (brandId) {
      loadCollaborators();
    }
  }, [brandId, loadCollaborators]);

  const addCollaborator = async () => {
    if (!selectedUser) return;
    
    try {
      await postData(
        `/api/brands/${brandId}/collaborators/${selectedUser}`,
        {}
      );
      await loadCollaborators();
      setSelectedUser('');
    } catch (error) {
      alert("Erreur lors de l'ajout du collaborateur");
    }
  };

  const removeCollaborator = async (userId) => {
    try {
      await deleteData(
        `/api/brands/${brandId}/collaborators/${userId}`
      );
      await loadCollaborators();
    } catch (error) {
      alert('Erreur lors de la suppression du collaborateur');
    }
  };

  const availableUsers = users.filter(user => 
    !collaborators.some(collaborator => collaborator.id === user.id)
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Collaborateurs</Typography>
        <Typography variant="caption" color="textSecondary">
          Gérez les utilisateurs qui peuvent accéder à cette brand
        </Typography>
      </Grid>
      
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, minHeight: '40px' }}>
          {collaborators.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              Aucun collaborateur ajouté
            </Typography>
          ) : (
            collaborators.map((collaborator) => (
              <Chip
                key={collaborator.id}
                label={collaborator.email}
                onDelete={() => removeCollaborator(collaborator.id)}
                deleteIcon={<DeleteIcon />}
                color="primary"
                variant="outlined"
              />
            ))
          )}
        </Box>
      </Grid>

      <Grid item xs={10}>
        <FormControl fullWidth>
          <TextField
            select
            label="Ajouter un collaborateur"
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            disabled={availableUsers.length === 0}
            size="small"
          >
            <MenuItem value="">
              <em>Sélectionner un utilisateur</em>
            </MenuItem>
            {availableUsers.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.email}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>
      </Grid>
      
      <Grid item xs={2}>
        <Button
          variant="contained"
          onClick={addCollaborator}
          disabled={!selectedUser}
          startIcon={<AddIcon />}
          fullWidth
          size="small"
        >
          Ajouter
        </Button>
      </Grid>
    </Grid>
  );
}
